import {
    Validate
} from '../global/_formValidation';

const allDevicesToggleEstTax = () => {
    $('.tax-toggle').on('touchstart click', function() {
        $('.est-tax-submit').toggleClass('open');
        ($('.est-tax-submit').hasClass('open')) ? $('#postalCode').focus(): $('#shopCart-proceed-checkout').focus();
        return false;
    });
};

const allDevicesPressEnterToEstTax = () => {
    $('#postalCode').on('keydown', function(event) {
        if (event.keyCode == 13) {
            event.preventDefault();
            estimateShippingAndTax();
            $('#postalCode').blur();
            return false;
        }
    });
};

const estimateShippingAndTax = () => {
    var orderTotal = $('#totalforJS').html();
    orderTotal = Number(orderTotal.replace(/[^0-9\.]+/g, ""));
    var zipcodeValue = $('#postalCode').val(),
        ajaxOptions = {
            type: "POST",
            url: "DdsCVEstimateShippingAndTax",
            dataType: "json",
            data: "storeId=301&langId=-1&catalogId=301&orderTotal=" + orderTotal + "&zipCode=" + zipcodeValue,
            beforeSend: function() {
                $('#ProcessImg').show();
            },
            success: function(json) {
                var successResp = json.JSON;
                var errorResp = json.JSONError;
                if (successResp != null) {
                    $("#totalTax").html(successResp.totalTax === null ? "" : successResp.totalTax);
                    $(".totalAmount").html(successResp.orderTotal === null ? "" : successResp.orderTotal);
                    $('#ProcessImg').hide();
                    $('#tax-estimate-disp').show();
                    $('#tax-estimate-disp').attr('aria-live', 'assertive');
                } else if (errorResp != null) {
                    $('#ProcessImg').hide();
                    $('#zipErrorRow').show();
                    $("#estimateShippingAndTaxErrors").html(errorResp);
                    $('#tax-estimate-disp').css("display", "");
                }
            }
        };
    if (Validate.isValidZip(zipcodeValue)) {
        $("#shippingRate").html("");
        $("#estimateShippingAndTaxErrors").html("");
        $.ajax(ajaxOptions);
    } else {
        $('#zipErrorRow').show();
        $('#estimateShippingAndTaxErrors').html("Please enter a 5 or 9 digit number.");
    }
    return false;
};

export {
    allDevicesPressEnterToEstTax,
    allDevicesToggleEstTax,
    estimateShippingAndTax
}
